'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SubLabel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('../../styles/scss/global.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function SubLabel(props) {
  var subLabel = props.subLabel;
  return _react2.default.createElement('h3', {
    className: 'subLabel-text'
  }, subLabel);
} // Global Style
// Core React


SubLabel.propTypes = {
  /** Text for subLabel */
  subLabel: _propTypes2.default.string.isRequired
};